export const spanish = {
  adminDashboard: {
    title: "Catálogo de Menús",
    headline: "seleccionar una plantilla",
    deleteMenu: "Delete menu",
    deleteInfo: "Quieres eliminar el menú: ",
    deleteBtn: "ELIMINAR",
    cancelBtn: "CANCELAR",
    menuDeletedSuccess: "El menú ha sido eliminado exitosamente",
    menuDeletedError: "No se ha podido eliminar el menu",
    menuCopySuccess: "El menu ha sido copiado exitosamente",
    menuCopyError: "No se ha podido copiar el menu",
    tabFood: "Carta",
    tabLunch: "Menú",
    tabAlcohol: "Vinos",
    tabSoda: "Bebidas",
    tabChild: "Menu infantil",
    tabChristmas: "Navidad y Año Nuevo",
  },
  clientView: {
    loading: "Cargando...",
    footerContent: "Powered by",
    footerLink: "GastronomiaQR.com",
    tabFood: "Carta",
    tabLunch: "Menú",
    tabAlcohol: "Vinos",
    tabSoda: "Bebidas",
    tabChild: "Menu infantil",
    tabChristmas: "Navidad y Año Nuevo",
    tabAllergens: "Alérgenos",
    location: "Dirección",
    openHours: "Horario",
    weekDays: "Día de la semana",
    middayHours: "Mediodía",
    eveningNightHours: "Horario de tarde / noche",
    contact: "Contacto",
    followUs: "Síguenos:",
    logoTitle: "GastronomíaQR",
    logoRestaurant: "Restaurant logo",
    expired:
      "Lo sentimos, el restaurant {{name}} no tiene el servicio activado. Puedes pedirle que lo activen :)",
    nonExist: "Lo sentimos, ¡el restaurant que buscas no existe!",
  },
  allergens: {
    names: {
      eggs: "Huevos",
      lactose: "Lactosa",
      fish: "Pescado",
      sea: "Moluscos",
      shellfish: "Crustáceos",
      nuts: "Frutos secos",
      soy: "Soja",
      gluten: "Libre de gluten",
      sesame: "Sésamo",
      mustard: "Mostaza",
      celery: "Apio",
      sulfur: "Sulfitos",
    },
    descriptions: {
      eggs: "Huevos y trazas de huevos",
      lactose:
        "Mantequilla, quesos, nata, y todos los derivados de la leche (incluída la lactosa)",
      fish: "Pescados y productos a base de pescados",
      sea: "Moluscos y productos a base de moluscos",
      shellfish: "Crustáceos y productos a base de crustáceos",
      nuts: "Maní, almendra, nuez, castañas, avellanas, y cualquier fruto seco",
      soy: "Soja y productos derivados de la soja",
      gluten: "Libre de centeno, avena, kamut, trigo, cebada y espelta.",
      sesame: "Granos de sésamo y otros productos a base de sésamo",
      mustard: "Mostaza y productos derivados de la mostaza",
      celery: "Apio y trozos de apio",
      sulfur:
        "Derivados del azufre empleados como aditivos por sus propiedades conservantes, antifúngicas, antimicrobianas y antioxidantes.",
    },
  },
  terms: {
    backBtn: "Volver",
    content:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.",
    title: "TÉRMINOS Y CONDICIONES GENERALES DE PRESTACIÓN DE SERVICIOS",
  },
  navigation: {
    logoTitle: "GastronomíaQR",
    faq: "FAQ",
    about: "Acerca de",
    support: "Soporte",
    buttonReservation: "RESERVAS",
    buttonComingSoon: "PRÓXIMAMENTE",
    freeFor: "100% Gratis por",
    expired: "El período de pruebas ha expirado",
    days: "días",
    terms: "Términos",
    logout: "Salir",
    editProfile: "Mi perfil",
    qrCodes: "Códigos QR",
    completePayment: "Completar el pago",
    logoutDialogTitle: "Salir",
    logoutDialogContent: "Seguro que desea salir de la aplicación ?",
    logoutCancelBtn: "CANCELAR",
    logoutLogoutBtn: "SALIR",
    paymentAgreement: "Acuerdo de pago",
    trialExpired:
      "Tu período de pruebas ha expirado. Puedes seguir utilizando la plataforma, no se perderá ningún dato, pero tus clientes no podrán acceder a los menús publicados. Puedes reactivar el servicio aceptando el acuerdo de pago.",
  },
  previewCard: {
    activeSwitch: "Activar",
    addMenu: "Agregar menú",
  },
  editTemplate: {
    returnBtn: "Volver",
    title: "Cambiar Diseño",
    headline: "SELECCIONAR UNA PLANTILLA",
    errors: {
      invalidFields: "Por favor verifique los campos resaltados",
    },
    dialog: {
      backBtn: {
        title: "SALIR DEL EDITOR",
        content:
          "No se han guardado los cambios, ¿está seguro que desea salir sin guardar?",
        backToAdmin: "SALIR",
        stay: "CANCELAR",
      },
    },
    hints: {
      copySection: "Copiar esta sección",
      deleteSection: "Eliminar esta sección",
      addSection: "Agregar nueva sección abajo",
      addLine: "Agregar nueva línea",
      deleteLastLine: "Eliminar la última línea",
      copyEntry: "Copiar este ítem",
      deleteEntry: "Eliminar este ítem",
      addEntry: "Agregar un ítem abajo",
    },
    editMenu: {
      save: "Guardar",
      addSection: "Agregar sección",
      addDish: "Agregar entrada",
      promo: "Sección destacada",
      color: "Colores",
      restoreTheme: "Restaurar las preferencias",
      undo: "Deshacer",
      redo: "Rehacer",
      preview: "Vista Previa",
      clearMenu: "Clear menu",
    },
    inputPlaceholders: {
      sectionDescription: "Descripción del Artículo",
      description: "descripción",
      footer: "pie de página",
      title: "Título",
      sectionName: "Nombre de la sección",
      specialEntry: "Valor de entrada especial",
    },
    themeEditor: {
      themeTitle: "Tema",
      heading: "Encabezado",
      description: "Descripción",
      price: "Precio",
      dishTitle: "Entrada seleccionada",
      priceType: "Tipo de precio",
      single: "Simple",
      double: "Doble",
      triple: "Triple",
      note: "Nota",
      none: "Ninguno",
      spice: "Picante",
      allergens: "Alérgenos",
      allergensColor: "Color Icono de alérgenos",
      select: "Seleccionar...",
      type: "Tipo...",
      nonDecimal: "Sin decimales",
      decimal: "Decimales",
    },
  },
  authentication: {
    signature: {
      title: "Mandato SEPA",
      formInfo: "Complete los datos del formulario y firme el mismo",
      inputLabel: "número de cuenta bancaria",
      skip: "OMITIR",
      back: "VOLVER",
      signBtn: "Firmar acuerdo",
      signature: "Firma",
      bankAccount: "Cuenta bancaria",
      clickToDraw: "Haga clic para firmar",
      clearField: "Borrar todo",
      send: "Enviar",
      save: "Guardar",
      logout: "Logout",
      usageDescription: "Utilice el mouse o la tableta para firmar",
      creditorName: "Emisor o Acreedor",
      creditorNameContent: "Mindful Software SL",
      creditorIdentifier: "Identificador de Emisor",
      creditorIdentifierContent: "B88234398",
      creditorAddress: "Dirección Emisor (Nombre de la calle y número))",
      creditorAddressContent: "Calle Henri Dunant, 17",
      postalCodeCity: "Código postal / Ciudad",
      postalCodeCityContent: "28036 Madrid",
      country: "País",
      countryContent: "España",
      mandateReference: "Referencia única del mandato",
      mandateReferenceContent: "436475678",
      debtor: "Deudor",
      debtorContent:
        "Mediante la firma de este formulario de Orden de Domiciliación, usted autoriza al emisor o acreedor identificado en el mismo a enviar órdenes a su entidad financiera para adeudar en su cuenta y a su entidad financiera para adeudar los importes correspondientes en su cuenta de acuerdo con las órdenes del acreedor indicado. Como parte de sus derechos, tiene derecho a ser reembolsado por su entidad financiera de acuerdo con los términos y condiciones del contrato suscrito con su entidad financiera. Dicho reembolso deberá reclamarse en un plazo de 8 semanas a partir de la fecha de en que se realizó el adeudo en su cuenta",
      confirmField: "Los campos marcados con * son obligatorios",
      nameOfDebtor: "Nombre del deudor (Persona/Empresa)",
      debtorAddress: "Dirección (Nombre de la calle y número)",
      debtorPostalCode: "Código Postal/Localidad",
      accountNumberIban: "Número de cuenta adeudo: IBAN",
      swiftBic: "BIC entidad deudora:",
      typeOfPayment: "Tipo de pago:",
      locationDate: "Fecha /lugar de Firma:",
      recurrentPayment: "Pago Recurrente",
      dateSign: "Madrid",
      signaturePlaceholder:
        "Firma(s)* Firma de personas autorizadas en la cuenta, en caso de poderes mancomunados dos firmas son necesarias",
      forInfoPurposes: "Observaciones:",
      forInfoPurposesTooltip:
        "Indique número de contrato, descripción del contrato, si hace el pago en nombre de otra persona oentidad, propósito del adeudo, Importe máximo autorizado...",
      returnSepaCore:
        "Al terminar el proceso, usted podrá descargar desde su perfil una copia firmada del mandato SEPA en formato PDF para su referencia",
      sepaCoreNote:
        "Nota: En su entidad financiera puede obtener información adicional sobre sus derechos relativos a este mandato.",
      or: "Ó",
      paymentAgreement: "Acuerdo de pago",
      signUpDoneFree: "Proceso de registro completado",
      signUpDoneFreeTitle:
        "Disfrute de la funcionalidad de la plataforma durante el período de pruebas. Recuerde que puede activar el servicio en cualquier momento completando el formulario de pago",
      signUpDoneFreeText: "¡Gracias por confiar en nosotros!",
      signUpDoneSigned: "Proceso de registro completado",
      signUpDoneSignedTitle: "El proceso de registro se ha completado con éxito",
      signUpDoneSignedText: "¡Gracias por confiar en nosotros!",
      continue: "Continuar",
      paymentAgreementPrice:
        "Acceso completo<br /><strong>99 EUR / Plan anual ó 9.90 EUR / Plan mensual</strong>",
      fullVersion:
        "Complete el formulario de pago para poder disfrutar de la plataforma sin límites",
      trialVersion:
        "Puede completar el pago más tarde y disfrutar de 7 días de prueba sin límites. Una vez transcurrido el período de pruebas, podrá continuar utilizando la plataforma, pero los usuarios no podrán ver los menús publicados. Puede reanudar el servicio a sus clientes en cualquier momento completando el formulario de pago.",
    },
    signUp: {
      facebookAddress: "Dirección de Facebook",
      instagramAddress: "Dirección de Instagram",
      twitterAddress: "Dirección de Twitter",
      correctFormatPhoto: "Formatos admitidos: jpg, png",
      maxWeightPhoto: "Tamaño máximo: 1 MB",
      companyData: "Datos de la empresa",
      title: "Registra tu empresa y comienza a crear tu carta",
      hr: "hs",
      tradeName: "Nombre comercial",
      localAddress: "Dirección del Local",
      postalCode: "Código postal",
      city: "Ciudad",
      businessNumber: "NIF/CIF",
      phone: "Teléfono",
      administrativePhone: "Teléfono de contacto (administrativo)",
      publicPhone: "Teléfono de contacto público",
      whatsApp: "Es WhatsApp",
      publicEmail: "E-mail de contacto público",
      openingTimes: "Horarios de apertura",
      reserveRanges: "Rangos de Reservas",
      midday: "Horas del mediodía",
      nightEvening: "Horas de tarde / noche",
      monday: "LUNES",
      tuesday: "MARTES",
      wednesday: "MIÉRCOLES",
      thursday: "JUEVES",
      friday: "VIERNES",
      saturday: "SÁBADO",
      sunday: "DOMINGO",
      next: "Siguiente",
      send: "Enviar",
      back: "Volver",
      addRange: "Agregar rango",
      weeksDays: "Días de la semana",
      clearAll: "Limpiar todo",
      emailAddress: "Dirección de correo electrónico",
      password: "Contraseña (debe contener al menos 8 caracteres de longitud)",
      repeatPassword: "Repite la contraseña",
      terms: "Acepto los términos y condiciones",
      titleRegisterFirstStep: "Registrarse",
      descriptionRegisterFirstStep: "Únete a nosotros en 2 simples pasos",
      edit: "Editar perfil",
      logout: "Salir",
      signUpDone: "Registro completado",
      welcomeMessageTitle: "Completa tu registro:",
      welcomeMessage:
        "Te hemos enviado un correo electrónico, donde encontrarás un enlace para completar el registro",
      enjoyMessage: "¡Te esperamos!",
      login: "ENTRAR",
    },
    signUpMobile: {
      welcome: "Bienvenido",
      pcEditorMessage:
        "Accede a todas las funcionalidades para crear y editar tus menús desde el navegador de tu ordenador",
      waitForYou: "¡Te esperamos!",
    },
    errors: {
      isRequired: "El campo es requerido",
      minLengthPass: "La contraseña debe contener al menos 8 caracteres",
      wrongPass: "La contraseña no contiene todos los caracteres requeridos",
      passNotMatch: "Las contraseñas no coinciden",
      termNotChecked: "Debe aceptarse la condición",
      incorrectMail: "Dirección de E-Mail incorrecta",
      authErr: "Clave o usuario inválido",
      emailNotExit: "El correo electrónico ingresado no existe",
      invalidFacebook: "Dirección de Facebook no válida",
      invalidTwitter: "Dirección de Twitter no válida",
      invalidInstagram: "Dirección de Instagram no válida",
      invalidBusinessNumber: "El NIF/CIF no es correcto, por favor compruébelo",
      invalidPhoneNumber: "El número de teléfono no válido",
      invalidPostalCode: "El código postal no es válido",
      wrongIban: "El IBAN no es válido. Debe constar de dos caracteres y 26 dígitos",
      wrongSwift: "El código BIC no es válido: debe contener entr 8 y 11 caracteres",
      apiError: "Algo salió mal, por favor inténtalo de nuevo",
    },
    signIn: {
      enter: "Entrar",
      haveAcc: "¿Todavía no tienes una cuenta?",
      register: "Regístrate",
      user: "Usuario",
      password: "Contraseña",
      login: "ENTRAR",
      forgotPass: "Has olvidado tu contraseña?",
      send: "Enviar",
      emailAddress: "Dirección de correo electrónico",
      back: "Volver",
      sentPassInfo:
        "Hemos enviado un enlace para restablecer la contraseña a la dirección de correo electrónico proporcionada. El enlace es válido por 30 minutos.",
      remindPassInfo:
        "Ingrese su dirección de correo electrónico a la que le enviaremos un enlace para restablecer su contraseña",
    },
    changePassword: {
      newPassword: "Nueva contraseña",
      RepeatNewPassword: "Repita la nueva contraseña",
      save: "Guardar",
      componentTitle: "Nueva contraseña",
      description: "Crear una nueva contraseña de al menos 8 caracteres de longitud",
    },
  },
  errorPage: {
    content: "Algo ha ido mal. Por favor visítanos en:",
    buttonContent: "GastronomíaQR",
  },
};
